import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DataMasksModule } from '../../../shared/data-masks/data-masks.module';

import { CollectorModule } from '@nx-ahs/script-collector';
import { BaseTranslateModule } from '@nx-ahs/base-translate';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { LayoutModule } from '../../../shared/components/layout/layout.module';
import { PrimaryPersonSearchComponent } from '../primary-person-search/primary-person-search.component';

import { FoundMembersComponent } from '../found-members/found-members.component';

@NgModule({
	declarations: [PrimaryPersonSearchComponent, FoundMembersComponent],
	exports: [PrimaryPersonSearchComponent, FoundMembersComponent],
	imports: [
		CommonModule,
		IonicModule,
		CollectorModule,
		BaseTranslateModule,
		LayoutModule,
		FontAwesomeModule,
		FlexLayoutModule,
		DataMasksModule
	]
})
export class PrimaryPersonSearchModule {}
